import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSalesDocumentTemplate as UpdateSalesDocumentTemplateMutation,
    UpdateSalesDocumentTemplateVariables as UpdateSalesDocumentTemplateVariables,
    SalesDocumentUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_SALES_DOCUMENT_TEMPLATE from '../mutations/update-sales-document-template.graphql';

export const useUpdateQuoteTemplate = (): {
    updateQuoteTemplate: (arg1: SalesDocumentUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateQuote, {loading, error}] = useMutation<
        UpdateSalesDocumentTemplateMutation,
        UpdateSalesDocumentTemplateVariables
    >(UPDATE_SALES_DOCUMENT_TEMPLATE);

    return {
        updateQuoteTemplate: (input: SalesDocumentUpdateInput) => updateQuote({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
